var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"w-100",attrs:{"id":_vm.fn_isNull(_vm.id)? _vm.id :'map'}},[_c('div',{staticClass:"marker-custom"})])])}
var staticRenderFns = []

export { render, staticRenderFns }